import {ToggleControl} from '../../../components/Controls/ToggleControl';
import {EditedProject} from '../EditedProject';

export function ShowInLIDControl({
    project,
    setProjectAndValidate
}: {
    project: EditedProject;
    setProjectAndValidate: (project: EditedProject) => void;
}) {
    return (
        <ToggleControl
            label="Show in LID"
            checked={project.ShowInLID}
            onChange={({checked}) =>
                setProjectAndValidate({
                    ...project,
                    ShowInLID: checked
                })
            }
        />
    );
}
